// extracted by mini-css-extract-plugin
module.exports = {"body":"order-confirmation_body__1GqFG","price":"order-confirmation_price__14TUY"};